
const loginstatus = {
    namespaced: true,
    state: {
        status: false,
        token: null,
        changePWD: false,
    },
    mutations: {
        Set_Status: (state, status) => {
            state.status = status;
            if (state.status == false) state.token = null;
        },
        Set_Token: (state, token) => {
            state.token = token;
        },
        Set_CHANGEPWD: (state, changePWD) => {
            state.changePWD = changePWD;
        }
    },
    actions: {
        setLoginStatus(context, options) {
            if(options.token) {
                context.commit('Set_Token', options.token);
            }
            if(options.changePWD !== null) {
                context.commit('Set_CHANGEPWD', options.changePWD);
            }
            context.commit('Set_Status', options.status);
        }
    }
}

export default loginstatus;